import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { CSSProperties } from 'react';
import KanbanCardBody from './KanbanCardBody';
import type { KanbanCardProps } from './types';

export type SortableKanbanCardProps = Omit<KanbanCardProps, 'overlay'>;

const SortableKanbanCard = ({ task, onOpen, onShowRelatedTasks }: SortableKanbanCardProps) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: task.ID,
        data: {
            type: 'task',
            task,
            fromStatus: Number(task.taskStatus),
        },
    });

    const style: CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.35 : undefined,
    };

    return (
        <div ref={setNodeRef} style={style}>
            <KanbanCardBody
                task={task}
                onOpen={onOpen}
                onShowRelatedTasks={onShowRelatedTasks}
                dragHandleProps={{ ...attributes, ...listeners }}
                className={isDragging ? 'task-kanban-card--dragging' : undefined}
            />
        </div>
    );
};

export default SortableKanbanCard;
